var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_48",
  "data-name": "Ellipse 48",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 25.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 25,
  fill: "none"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1397",
  "data-name": "Group 1397",
  transform: "translate(15.5 18.5)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  x2: 20,
  transform: "translate(0 7)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_26",
  "data-name": "Line 26",
  x2: 7,
  y2: 7,
  transform: "translate(13)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_27",
  "data-name": "Line 27",
  y1: 7,
  x2: 7,
  transform: "translate(13 7.004)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}));
function SvgNavRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_15_13",
    "data-name": "Component 15 \\u2013 13",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRight);
export default __webpack_public_path__ + "static/media/navRight.03e886ada87fe2c690b607c8d2ca407d.svg";
export { ForwardRef as ReactComponent };